import * as React from "react";
const TooltipIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_144_3707)">
      <path
        d="M8 0.833008C12.2339 0.833184 15.6658 4.26608 15.666 8.5C15.6658 12.7339 12.2339 16.1658 8 16.166C3.76608 16.1658 0.333184 12.7339 0.333008 8.5C0.333184 4.26608 3.76608 0.833184 8 0.833008ZM8 7.75C7.5859 7.75 7.25018 8.08594 7.25 8.5V11.166L7.25391 11.2432C7.29238 11.6213 7.61172 11.916 8 11.916C8.38828 11.916 8.70762 11.6213 8.74609 11.2432L8.75 11.166V8.5L8.74609 8.42285C8.70747 8.04488 8.38817 7.75 8 7.75ZM8 5.08301C7.5859 5.08301 7.25018 5.41894 7.25 5.83301C7.25 6.24722 7.58579 6.58301 8 6.58301H8.00684L8.08301 6.5791C8.46134 6.54083 8.75684 6.22144 8.75684 5.83301C8.75667 5.44472 8.46126 5.12516 8.08301 5.08691L8.00684 5.08301H8Z"
        fill="#404041"
      />
    </g>
    <defs>
      <clipPath id="clip0_144_3707)">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default TooltipIcon;
